import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

export const generatePracticePaper = async (payload) => {
  try {
    const token = localStorage.getItem("userToken");
    const response = await axios.post(`${BASE_URL}/api/practice-paper/generate`, payload, {
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
